import { useDispatch, useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { COMPANY, PROJECT, USER } from "../../services/actions";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Button, Container, Box, Grid, Tab, Tabs } from "@mui/material";
import InfoCard from "../extra/InfoCard";
import Form from './Form';
import ActionBar from "../extra/ActionBar";
import ProjectImg from './project.jpg'
import SearchBar from "../extra/SearchBar";
import InfoCard2 from "../extra/InfoCard2";
import { isBase64Image } from "../../libs/Libs";


export default function View() {
  let dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)
  const [defV, setDefV] = React.useState({})
  const navigate = useNavigate();
  let ref = React.createRef()
  let ref2 = React.createRef()
  let projectState = useSelector((state) => state?.projectState)
  let projectallState = useSelector((state) => state?.projectallState)
  let companyState = useSelector((state) => state?.companyState)
  const [companies, setCompanies] = React.useState([])
  let user = useSelector((state) => state?.loginState?.auth)

  React.useEffect(() => {
    setCompanies(companyState?.data?.results)
  }, [companyState?.data])


  return (
    <>

      {open ? <Form companies={companies}
        defaultValues={defV}
        onSubmit={(data) => {
          if (!isBase64Image(data.image)) {
            delete data["image"]
          }
          let action = data.id ? `${PROJECT}_PATCH` : `${PROJECT}_POST`
          dispatch({ type: action, payload: data })
        }}
        back={() => { setOpen(false) }}
      />
        : <Container fluid className="py-3">
          <ActionBar
            showGrid={[2, 5]}
            hasPermission={user.permissions.includes('project.add_project')}
            label="Project" setOpen={(s) => {
              if (user.main_role == "Company") {
                setCompanies(user?.companies)
              } else {
                dispatch({ type: `${COMPANY}_GET`, payload: 0 })
              }
              setOpen(true);
            }}
            btnLabel="ADD PROJECT" />
          <SearchBar bylist={["project_name"]} handleSearch={()=>{}} />

          <Grid container spacing={1}>
            {projectallState?.data?.results.map((data) => {
              if (!data.image) {
                data.image = ProjectImg
              }

              data.no_users = data?.users?.length
              return <Grid size={{ xs: 12, sm: 4, md: 3 }}>
                <InfoCard2
                  keys={[
                    "image",
                    "project_name",
                    "company_name",
                    "country",
                    "Duration",
                    "duration",
                    "Verify",
                    "verify",
                    "Camera",
                    "camera_count"
                  ]}
                  data={data}
                  onClick={() => {
                    //navigate("/timelapse-preview/", {})
                  }}
                  onAction={(action, data) => {
                    if (action == "Edit") {
                      setDefV(data);
                      setOpen(true);
                    } else if (action == "Delete") {
                      dispatch({ type: `${PROJECT}_DELETE`, payload: data?.id })
                    }
                  }}
                />
              </Grid>
            })}
          </Grid>
        </Container>}

    </>
  )
}